import CustomMessengerFixed from '@/views/messenger/custom_messenger_fixed.vue'
import { createApp } from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html';

function confirm({ message, status }) {
  return new Promise((resolve, reject) => {
    const confirmInstance = createApp(CustomMessengerFixed, {
      message: message,
      status: status,
    })
    confirmInstance.use(VueDOMPurifyHTML, {
      default: {
        ADD_ATTR: ['target']
      },
    })

    const unmount = () => {
      confirmInstance.unmount()
      document.body.removeChild(parentNode)
    }

    setTimeout(unmount, 3000)

    const parentNode = document.createElement('div')
    document.body.appendChild(parentNode)

    confirmInstance.mount(parentNode)
  })
}

export default confirm
